import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import * as cfg from "./config";

import rootReducer from "./reducers"; // <-- no longer a function

import { authServiceMiddlewareCreator } from "@authzsvc/api-lib";

const middleware = [thunk, authServiceMiddlewareCreator(cfg)];

const composedEnhancers = window.__REDUX_DEVTOOLS_EXTENSION__
  ? compose(
      applyMiddleware(...middleware),
      window.__REDUX_DEVTOOLS_EXTENSION__(),
    )
  : applyMiddleware(...middleware);

export default createStore(rootReducer, {}, composedEnhancers);
